import type { VoidFunctionComponent } from 'react';

import ConfirmModal from '../../../../generic/ConfirmModal';
import Link from '../../../../generic/Link/Link';
import useAuthenticationSettingsContext from '../hooks/useAuthenticationSettingsContext';

type Props = {
  onHide: () => void;
  onConfirm: () => void;
  isOpen: boolean;
  domainToRemove: string | null;
};

/**
 * A modal that prompts the user to confirm that they want to remove a claimed domain.
 */
const RemoveDomainConfirmationModal: VoidFunctionComponent<Props> = ({ isOpen, domainToRemove, onHide, onConfirm }) => {
  const {
    settings: { loginSubdomain },
  } = useAuthenticationSettingsContext();

  const loginUrl = (
    <Link to={loginSubdomain || window.location.origin} openInNewTab>
      {loginSubdomain ? new URL(loginSubdomain).host : window.location.host}
    </Link>
  );
  return (
    <ConfirmModal
      isOpen={isOpen}
      title="Remove claimed domain?"
      body={
        <>
          <p className="margin-bottom-md">
            Are you sure you’d like to remove <b>{domainToRemove}</b>? You will have to verify this domain again if
            you’d like to reclaim it.
          </p>
          <div className="gray-box">
            <b>Note:</b> After this change, users with a <em>@{domainToRemove}</em> email will be required to directly
            visit {loginUrl} to sign in or sign up.
          </div>
        </>
      }
      onHide={onHide}
      onConfirm={onConfirm}
      confirmText="Remove Domain"
    />
  );
};

export default RemoveDomainConfirmationModal;
